import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../helpers/axiosConfig";

const About = () => {
  const [data, setData] = useState({
    title: "",
    paragraphs: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { i18n, t } = useTranslation('global');

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get(`/users/about/?lang=${i18n.language}`);
        setData(response.data);
      } catch (err) {
        console.error("Failed to load about content", err);
        setError(t('about.loadError'));
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, [i18n.language]);

  if (loading) {
    return (
      <div className="about container">
        <div className="about__info2">{t('loading.loading')}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="about container">
        <div className="about__info2 error">{error}</div>
      </div>
    );
  }

  return (
    <div className='about container'>
      <div className='about__info2'>
        <div>
          <h2>{data.title}</h2>
        </div>
        {data.paragraphs.map((p, index) => (
          <div style={{ marginBottom: '40px' }}>
            <p>{p.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;